import { Controller } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import { AgencyFormRadioProps } from '../../interfaces/types';
import { RadioGroup } from '@navi/web-ui/lib/components';

export const AgencyFormRadioInput = (props: AgencyFormRadioProps) => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled,
    styles,
    inputLabel,
    validationMessage,
    options,
    isRequired = true
  } = props;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <RadioGroup
            label={inputLabel}
            required={isRequired}
            onChange={onChange}
            value={value}
            name={name}
            options={options}
            disabled={isEditDisabled}
          />
        )}
      />
      {errors?.[name] ? (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      ) : null}
    </>
  );
};

export default AgencyFormRadioInput;
